import React, { useContext, memo } from 'react';
import { context } from '../../../context';
import { RatingDistributionContainer, RatingStyle, Border } from './Styled';
import { ProgressBar, Star } from '../../atoms';
import { useHandleFilter } from '../../../hooks';

const Distribution = (props: any) => {
  const { dispatchMetrics } = props;
  const { data, queryParam } = useContext(context);
  const distribution = data?.rating?.distribution;
  const comments = data?.comments;
  const total = data?.rating?.count;
  const isEmpty = !distribution?.length && !total;
  const { handleFilter } = useHandleFilter();

  if (isEmpty) {
    return null;
  }

  const onClick = ({ target }: any) => {
    const filter = target.closest('div[data-filter]').getAttribute('data-filter');
    handleFilter({ rating: [filter] });
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'avaliacoes-grafico',
      label: `${filter}-estrela` + `${filter !== '1' ? 's' : ''}`,
    });
  };

  const renderRatings = [5, 4, 3, 2, 1].map(number => {
    const key = `rating_${number}`;
    const { count } = distribution[key];
    const percentage = Number(((count * 100) / total).toFixed(1));
    const opacity = count ? 1 : 0.5;
    const handleClick = count && comments ? onClick : () => null;
    const className = queryParam.rating.includes(number.toString()) ? 'active' : '';

    return (
      <RatingStyle className={className} key={number} opacity={opacity} onClick={handleClick} data-filter={number}>
        <Border>
          <span>{number}</span>
          <Star size={16} fillPercentage={100} />
        </Border>
        <ProgressBar percentage={percentage} />
        <span>{percentage}%</span>
      </RatingStyle>
    );
  });

  return <RatingDistributionContainer>{renderRatings}</RatingDistributionContainer>;
};

const RatingDistribution = memo(Distribution);

export default RatingDistribution;
export { RatingDistribution };
